import { Link } from "react-router-dom";

export default function Paginate({
  pages,
  page,
  isAdmin = false,
  isCreator = false,
  keyword = "",
  sort = "",
  tag = "",
  min = undefined,
  max = undefined,
  itemType = "all",
  language = "all",
}) {
  const currentPage = Number(page) || 1;
  const baseUrl = isCreator
    ? "/profile/creator/search"
    : tag
      ? `/user/creator/${tag}/search`
      : "/search";

  if (!(pages > 1)) return null;

  const buildUrl = (targetPage) => {
    if (isAdmin) return `/admin/productlist/${targetPage}`;

    const urlParts = [baseUrl];
    if (keyword) urlParts.push(keyword);
    if (sort) urlParts.push(`sort/${sort}`);
    if (min) urlParts.push(`min/${min}`);
    if (max) urlParts.push(`max/${max}`);
    urlParts.push(`page/${targetPage}`);

    const query = new URLSearchParams();
    if (itemType && itemType !== "all") query.set("itemType", itemType);
    if (language && language !== "all") query.set("language", language);
    const queryString = query.toString();

    return queryString ? `${urlParts.join("/")}?${queryString}` : urlParts.join("/");
  };

  return (
    <nav className="pt-20 flex justify-center" aria-label="Pagination">
      <div className="inline-flex flex-wrap items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-3 py-2 shadow-md shadow-slate-200/70">
        <Link
          to={buildUrl(Math.max(1, currentPage - 1))}
          className={`inline-flex h-10 items-center justify-center rounded-xl px-4 text-sm font-semibold no-underline transition ${
            currentPage <= 1
              ? "pointer-events-none bg-slate-100 text-slate-400"
              : "bg-slate-100 text-slate-700 hover:bg-slate-200"
          }`}
        >
          Prev
        </Link>

        {[...Array(pages).keys()].map((x) => {
          const targetPage = x + 1;
          const isActive = targetPage === currentPage;
          return (
            <Link
              key={targetPage}
              to={buildUrl(targetPage)}
              className={`inline-flex h-10 min-w-10 items-center justify-center rounded-xl px-3 text-sm font-semibold no-underline transition ${
                isActive
                  ? "bg-sky-600 text-white shadow-md shadow-sky-300/50"
                  : "bg-slate-100 text-slate-700 hover:bg-slate-200"
              }`}
            >
              {targetPage}
            </Link>
          );
        })}

        <Link
          to={buildUrl(Math.min(Number(pages), currentPage + 1))}
          className={`inline-flex h-10 items-center justify-center rounded-xl px-4 text-sm font-semibold no-underline transition ${
            currentPage >= Number(pages)
              ? "pointer-events-none bg-slate-100 text-slate-400"
              : "bg-slate-100 text-slate-700 hover:bg-slate-200"
          }`}
        >
          Next
        </Link>
      </div>
    </nav>
  );
}
